import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // Fetch translations from a server
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Initialize react-i18next
  .init({
    lng: 'en-GB',
    fallbackLng: 'en-GB',
    // ns: ['translation'],
    // defaultNS: 'translation',
    debug: true,
    backend: {
      loadPath: '/locales/{{lng}}.json', // ensure the path is correct
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;
